module.exports = __webpack_public_path__ + "media/6.fd810cb6.wav";